import { createFileRoute } from '@tanstack/react-router';
import { CurrenciesListPage } from '@/features/catalog/currencies-list-page.js';

export const Route = createFileRoute('/_app/settings/currencies')({
  component: CurrenciesListPage,
});
